import { styled } from 'theme'

export const StyledAppLayoutBreadcrumb = styled.div`
  background-color: white;
  color: blue;
  padding: 1rem;
`
